import ApiRequest from "../utils/ApiRequest";

export default class Modules {

  getAll = async () => {
    return await ApiRequest.set("/v1/modules", "GET");
  }

  create = async (module) =>{
    return await ApiRequest.set("/v1/modules", "POST", module)
  }

  getTraining = async(subModuleId) => {
    return await ApiRequest.set(`/v1/submodules/${subModuleId}/training`, "GET");
  }

}
